import React, {useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Divider, Grid, Stack} from "@mui/material";
import InputField from "../../components/InputField";
import AlertBar from "../../components/AlertBar";
import Form from "../../components/Form";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import SelectField from "../../components/SelectField";

const genders = [
    {label: "Diesel", value: "Diesel"},
    {label: "Petrol", value: "Petrol"},
    {label: "Gas", value: "Gas"},
];
export default function AddTruck(props) {
    const form = useRef();
    const alert = useRef();
    const plateNumberRef = useRef();
    const chasesNumberRef = useRef();
    const makeRef = useRef();
    const modelRef = useRef();
    const capacityRef = useRef();
    const fuelTypeRef = useRef();

    const [plateNumber, setPlateNumber] = useState(props.data?.plateNumber);
    const [chasesNumber, setChasesNumber] = useState(props.data?.chasesNumber);
    const [make, setMake] = useState(props.data?.truckMake);
    const [model, setModel] = useState(props.data?.truckModel);
    const [capacity, setCapacity] = useState(props.data?.capacity);
    const [fuelType, setFuelType] = useState(props.data?.fuelType);
    const [canSubmit, setCanSubmit] = useState(true);
    const submit = () => {
        let data = {
            plateNumber,
            chasesNumber,
            truckMake: make,
            truckModel: model,
            capacity,
            fuelType
        }
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            if (props.data?.truckId) {
                window.axios
                    .put(`${BASE_URL}api/settings/truck/${props.data?.truckId}`, data)
                    .then(response => {
                        alert.current.showSuccess("Update Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            props.modal.current.hide();
                            props.loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            } else {
                window.axios
                    .post(`${BASE_URL}api/settings/truck`, data)
                    .then(response => {
                        alert.current.showSuccess("Create Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            props.modal.current.hide();
                            props.loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            }
        }
    }
    return (
        <Box>
            <Form ref={form}>
                <AlertBar ref={alert}/>
                <Grid container spacing={2} sx={{p: 1}}>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={plateNumberRef}
                            defaultValue={plateNumber}
                            type="text"
                            label="Plate Number"
                            onChange={(value) => setPlateNumber(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={chasesNumberRef}
                            defaultValue={chasesNumber}
                            type="text"
                            label="Chases Number"
                            onChange={(value) => setChasesNumber(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={makeRef}
                            defaultValue={make}
                            type="text"
                            label="Make"
                            onChange={(value) => setMake(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={modelRef}
                            defaultValue={model}
                            type="text"
                            label="Model"
                            onChange={(value) => setModel(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={capacityRef}
                            defaultValue={capacity}
                            type="text"
                            label="Seat Capacity"
                            onChange={(value) => setCapacity(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectField
                            ref={fuelTypeRef}
                            required={true}
                            label="Fuel Type"
                            options={genders}
                            value={fuelType}
                            onChange={(value) => setFuelType(value)}
                        />
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <Stack alignItems="center"
                               justifyContent="center">
                            <Grid item xs={2}>
                                <Button
                                    disabled={!canSubmit}
                                    sx={{my: 1, textTransform: "none"}}
                                    disableElevation
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => submit()}
                                >
                                    {props.data?.truckId ? "Update" : "Save"}
                                </Button>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Form>
        </Box>
    );
}